import React from 'react';
import { ButtonToolbar, DropdownButton, MenuItem, Glyphicon, Button, OverlayTrigger, Popover } from 'react-bootstrap';
import { DragSource } from 'react-dnd';

const componentSource = {
    beginDrag (props, monitor, component) {
        component.overlay.hide();

        return {
            id: "placeholder",
            componentType: props.component.id,
            developerName: "",
            content: "New Component",
            componentId: null,
            order: 0,
            pageContainerId: ""
        };
    },

    canDrag (props, monitor) {
        return props.droppedOn == null && props.editing.id == null;
    }
};

@DragSource('component', componentSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
}))
class SidebarComponent extends React.Component {

    constructor(props) {
        super(props);
    }

    onOverlay = (overlay) => {
        this.overlay = overlay;
    }

    render() {
        const { connectDragSource, connectDragPreview } = this.props;

        var styles = {};

        if (this.props.droppedOn != null || this.props.editing.id != null) {
            styles["opacity"] = 0.3;
            styles["cursor"] = 'not-allowed';
        }

        return connectDragSource(
            <li data-element={this.props.component.id}>
                <OverlayTrigger trigger={['hover']} placement="right" overlay={this.props.popover} container={this.props.container} ref={this.onOverlay}>
                    {
                        connectDragPreview(
                            <div style={styles} data-flow={this.props.component.flow} data-name={this.props.component.id} className="sidebar-component">
                                <Glyphicon glyph={this.props.component.icon}/>
                                <span>{this.props.component.name}</span>
                            </div>
                        )
                    }
                </OverlayTrigger>
            </li>
        );

    }

}

export default SidebarComponent;
